export const quotesList = `
Consistency beats talent when talent stops showing up
Small daily progress quietly creates massive success
Discipline today builds freedom and confidence tomorrow
Hard days matter most—never stop when it gets tough
Success is built silently through daily repeated effort
Show up daily even when motivation completely disappears
Persistence today secures opportunities for your future
Difficult days are preparation days, not failure signs
One focused hour daily compounds into life-changing skill
Momentum grows faster when discipline replaces motivation
You don’t need perfection, only consistent daily action
Every effort compounds, even when results stay invisible
Stay committed long after excitement and hype are gone
Winners are consistent long after others choose comfort
Progress is invisible before it becomes undeniable truth
Your daily habits quietly shape your future direction
Keep going—results are closer than your doubts suggest
Comfort delays growth, discipline accelerates transformation
Consistency slowly turns dreams into unavoidable reality
Success is rented, and payment is required every day
Do the work others avoid and you gain their results
Patience and persistence outperform short bursts of effort
Discipline begins when excuses are no longer negotiated
Today’s effort becomes tomorrow’s competitive advantage
Stop waiting for perfect conditions—start where you are
Slow progress still moves you closer to the finish line
Trust the process even when emotions say otherwise
The daily grind quietly prepares you for greatness
Daily effort builds confidence no failure can shake
Results always follow repeated and intentional action
Your discipline defines the limits of your achievement
Boring days are the foundation of extraordinary lives
Stay consistent especially when it feels inconvenient
Dreams demand discipline, not motivation or wishful hope
Excuses steal progress; discipline protects your future
Progress continues as long as quitting is avoided
Consistency brings clarity when direction feels uncertain
Control daily inputs and results will take care of themselves
Build habits strong enough to carry you forward
Success becomes predictable when effort is consistent
Your future self depends on today’s disciplined actions
Do something today your future will appreciate deeply
Every repetition strengthens your foundation of skill
Persistence turns every failure into useful feedback
Greatness is earned quietly through consistent execution
Discipline chooses long-term reward over short comfort
Daily effort compounds like interest over time
Be reliable to your own goals before others trust you
Show up tired, uncertain, or afraid—just show up
Consistency is self-respect demonstrated through action
Master ordinary actions to unlock extraordinary results
Never break the chain of daily effort
Long-term vision must defeat short-term emotion
One step daily beats occasional bursts of intensity
Effort today reduces struggle and stress tomorrow
Consistency builds confidence that no doubt can destroy
Discipline is the bridge between goals and success
Repetition slowly creates mastery and deep competence
Stay loyal to the process, not temporary feelings
Your habits vote for your future every single day
Results reward those who refuse to quit early
The grind is temporary; quitting creates permanent regret
Every single day matters more than you realize
You eventually become what you repeatedly practice
Discipline creates momentum that motivation never can
Your best days are built through effort, not luck
Stay patient—progress happens quietly in the background
Emotional decisions often sabotage disciplined progress
Consistency separates dreamers from true achievers
Small actions done daily win the longest battles
You don’t rise to goals—you fall to habits
Today’s discipline removes tomorrow’s regret
Success favors those who endure discomfort longest
Progress naturally follows persistent daily effort
Focus on consistency, not speed or comparison
Discipline is freedom disguised as responsibility
Keep building even when no one notices your effort
Every honest effort adds strength to your foundation
Consistency slowly makes difficult things feel easy
Your routine determines your results more than talent
Success is the sum of disciplined daily choices
Stay disciplined even when nobody is watching
Persistence always outlasts resistance and doubt
Trust slow growth—it creates lasting success
One day of effort moves you closer to mastery
Never underestimate the power of steady work
Discipline creates direction when motivation fades
Build today what others keep postponing forever
Consistency turns struggle into strength over time
Effort compounds quietly before results appear
Daily discipline beats rare moments of brilliance
Keep your promises to yourself above all else
Small wins accumulate into unbreakable confidence
Don’t stop simply because progress feels uncomfortable
Consistency is how dreams become real outcomes
Master the habit of showing up daily
Growth always begins outside the comfort zone
Routine fuels success more reliably than inspiration
Stay committed to action, not emotional reactions
One disciplined day at a time wins everything
Long-term success loves boring, consistent effort
Do the work repeatedly, not occasionally
Discipline sharpens raw potential into real skill
The process itself is the real reward
Stay steady even when progress feels slow
Persistence creates opportunities others never reach
Today’s discipline becomes tomorrow’s strength
Small steps beat standing still every time
Keep investing effort even without immediate results
Consistency builds unstoppable momentum over time
Progress is built patiently, never rushed
Discipline grows confidence through reliability
Stay consistent even when doubt appears
Hard work compounds faster than luck ever will
Repetition transforms weakness into reliable skill
Build habits that continuously build you
Show up even on days you feel off
Discipline is choosing growth over comfort
Every day offers a chance to improve slightly
Don’t quit just before the breakthrough moment
Persistence always pays interest eventually
Be patient with results, strict with effort
Consistency builds character before success arrives
Keep going—momentum is already forming
Discipline removes uncertainty from progress
Stay focused on daily execution only
Success demands repetition more than intelligence
Today’s effort matters more than motivation
Routine creates results you can rely on
Consistency slowly builds deep confidence
Do it again, even when it feels boring
Discipline is practiced, not emotionally felt
Your grind determines your growth curve
Progress rewards patience, not impatience
Small actions shape massive long-term outcomes
Never miss twice—protect your consistency
Consistency builds trust within yourself
Hard work feels easier when it’s routine
Persistence is a powerful competitive advantage
Focus on daily excellence, not outcomes
Show up before you ever feel ready
Discipline gives you a long-term edge
Effort today creates ease and clarity tomorrow
Consistency is quiet confidence in motion
Keep stacking small wins without ego
Growth requires repetition, not intensity
Don’t wait for clarity—create it through work
Discipline turns chaos into clarity
Stay steady even under pressure
Success rewards reliability more than talent
Consistency builds habits that cannot be shaken
Routine always beats randomness in the long run
You win simply by not quitting
Discipline fuels sustainable long-term success
Keep moving forward no matter how small
Progress demands patience and persistence
Show up imperfectly, but consistently
Discipline creates opportunities luck cannot
Repeat the work until it becomes automatic
Trust consistency over bursts of intensity
Do the work again, without negotiation
Persistence creates advantage over time
Discipline generates momentum naturally
Small daily efforts always compound
Stay consistent and you become dangerous
Growth happens when effort is daily
Discipline builds freedom, not restriction
Protect your streak at all costs
Effort never lies about progress
Consistency builds mental resilience
Master the daily grind patiently
Progress follows those who persist
Discipline is the highest form of self-leadership
Routine quietly fuels achievement
Every single day counts toward success
Keep executing the fundamentals daily
Consistency always outlasts motivation
Discipline sharpens focus and clarity
Small actions build a powerful future
Show up relentlessly without excuses
Discipline builds deep self-belief
Stay consistent even when bored
Repetition builds excellence naturally
Progress is earned through daily effort
Discipline prevents future regret
Keep working quietly and patiently
Routine often beats raw talent
Discipline is daily personal power
Never stop showing up for yourself
Consistency wins every long game
Growth rewards patience paired with effort
Discipline defines long-term success
One disciplined day creates momentum
Persistence slowly builds real strength
Keep standards high every single day
Discipline itself is a habit
Progress favors the consistent worker
Stay steady and focused always
Effort never betrays commitment
Success always follows discipline
Show up before motivation appears
Discipline builds identity and confidence
Daily effort creates lasting destiny
Routine strengthens reliability
Stay loyal to the process daily
Consistency builds mental toughness
Discipline creates visible results
Small steps win long races
Persistence fuels progress continuously
Keep grinding patiently every day
Discipline defeats distraction consistently
Build habits, not excuses
Progress demands consistent repetition
Stay disciplined even when uncomfortable
Discipline brings clarity to chaos
Daily execution always matters
Persistence builds unstoppable momentum
Focus only on today’s work
Consistency strengthens discipline itself
Effort compounds every single day
Discipline must be earned daily
Keep working even when unnoticed
Consistency shapes true excellence
Progress must be intentional
Discipline means reliability to yourself
Focus on the long-term game
One day stronger than yesterday
Persistence outworks doubt every time
Routine builds predictable success
Consistency creates confidence
Discipline fuels achievement quietly
Keep showing up without excuses
Progress always favors patience
Daily habits shape outcomes
Discipline is a daily decision
Consistency always beats excuses
Growth loves repeated effort
Keep stacking effort patiently
Discipline drives measurable results
Persistence creates true mastery
Success always rewards consistency
Stay disciplined under pressure
Routine produces reliable results
Discipline creates momentum naturally
Today’s effort always matters
Progress is built every day
Consistency creates inner strength
Discipline fuels resilience
Stay patient and persistent
Keep grinding forward daily
Discipline builds lasting success
Show up consistently without fail
Persistence builds confidence over time
Routine beats randomness always
Discipline sharpens execution
Progress rewards discipline
Stay committed every day
Consistency builds greatness
Discipline creates direction
Keep moving forward daily
Daily effort compounds powerfully
Persistence always wins eventually
Discipline shapes destiny
Progress is earned daily
Stay consistent no matter what
Routine builds mastery
Discipline creates success
One step daily matters
Persistence creates advantage
Keep building patiently
Discipline strengthens character
Consistency builds momentum
Progress follows effort
Stay disciplined daily
Routine fuels achievement
Discipline wins long-term
Persistence drives progress
Keep showing up
Discipline builds trust
Consistency fuels success
Progress loves patience
Discipline sharpens execution
Routine creates results
Stay committed always
Discipline defines success
Persistence builds resilience
Daily effort matters
Consistency creates excellence
Discipline drives growth
Keep grinding forward
Progress is daily work
Discipline builds confidence
Persistence fuels mastery
Routine shapes results
Discipline wins daily
Stay consistent long-term
Progress follows discipline
Keep pushing daily
Discipline creates momentum
Persistence never fails
Daily discipline matters
Consistency builds strength
Progress is earned
Discipline shapes future
Routine builds success
Persistence drives achievement
Discipline is power
Keep going forward
Consistency fuels growth
Progress demands effort
Discipline creates stability
Persistence builds skill
Routine creates mastery
Discipline defines results
Keep moving daily
Consistency builds confidence
Progress loves discipline
Persistence pays off
Routine fuels progress
Discipline never lies
Daily effort builds future
Consistency creates winners
Discipline drives success
Persistence beats doubt
Routine builds strength
Discipline shapes outcomes
Keep executing daily
Progress follows repetition
Consistency builds resilience
Discipline wins always
Persistence fuels growth
Routine creates momentum
Discipline builds excellence
Keep showing up daily
Progress rewards effort
Consistency drives results
Discipline creates clarity
Persistence shapes mastery
Routine fuels discipline
Keep moving forward
Discipline creates success
Consistency builds power
Progress is intentional
Persistence builds confidence
Routine shapes destiny
Discipline defines growth
Keep grinding daily
Consistency fuels momentum
Progress demands patience
Discipline never quits
Persistence drives excellence
Routine creates results
Discipline builds future
Consistency creates progress
Keep pushing forward
Discipline wins daily battles
Persistence builds strength
Routine fuels success
Discipline creates winners
Progress is daily effort
Consistency defines achievement
Discipline shapes destiny
Persistence never lies
Routine builds greatness
Consistency is the key—never stop showing up
`.split('\n').filter(line => line.trim() !== '');
